import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './AdminPanel.css'
import Usernav from './Usernav';
import Sellernav from './Sellernav';
import Adminnav from './Adminnav';
import { useNavigate } from 'react-router-dom';
const AdminPanel = () => {
  var nav = useNavigate()

  function navCoupons(){
    nav('/AdminPanel/Coupons')
  }

  function navProductCatlog(){
    nav('/AdminPanel/ProductCatlog')
  }

  function navOrders(){
    nav('/AdminPanel/AllOrders')
  }

  
  function navUserConfig(){
    nav('/AdminPanel/UserConfig')
  }
  return (
   <>
   {
         sessionStorage.getItem("c")==='User'?<Usernav/>:sessionStorage.getItem("c")==='Seller'?<Sellernav/>:sessionStorage.getItem("c")==='Admin'?<Adminnav/>:<Usernav/>
   }

                <div className="card h-100 text-center panel" >
                <div className="card-body row ">
                <i className="fas fa-users-cog icon col" onClick={()=>navUserConfig()}></i>
                <i className="fas fa-database icon col" onClick={()=>navProductCatlog()}></i>
                <i className="fas fa-heart icon col" onClick={()=>navCoupons()}></i>
                <i className="fas fa-truck icon col" onClick={()=>navOrders()}></i>
                </div>
                <div className="card-body row content">
                <b className="col" style={{paddingLeft:"3.0px"}}>User Configuration</b>
                <b className="col">Product Catlog</b>
                <b className="col" style={{paddingLeft:"20px"}}>Coupons</b>
                <b className="col">Orders</b>
                </div>
            </div>
                
   </>
  )
}

export default AdminPanel